import { useMemo } from 'react';
import {
  GALLERY_CONSTS,
  migrateOptions,
  extendNestedOptionsToIncludeOldAndNew,
} from 'pro-gallery-lib';
import { useStyles } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';

import { EMediaLayout } from 'settings/constants';
import { styles as styleParams } from 'settings/group';

import { MediaLayoutMap, bgColorParam, actionsColorParam } from './constants';

export function useFullscreenOptions() {
  const { isMobile } = useEnvironment();

  return useMemo(
    () =>
      extendNestedOptionsToIncludeOldAndNew({
        galleryLayout:
          GALLERY_CONSTS.layoutParams_structure_galleryLayout.SLIDESHOW,
        slideshowInfoSize: 0,
        slideAnimation:
          GALLERY_CONSTS.behaviourParams_gallery_horizontal_slideAnimation
            .SCROLL,
        cubeType: 'fit',
        scrollSnap: true,
        showArrows: !isMobile,
        behaviourParams: {
          item: {
            video: {
              volume: 1,
              enableControls: true,
            },
          },
        },
        hoveringBehaviour:
          GALLERY_CONSTS.behaviourParams_item_overlay_hoveringBehaviour
            .NEVER_SHOW,
      }),
    [],
  );
}

export function useGalleryOptions() {
  const styles = useStyles();
  const { isMobile } = useEnvironment();

  const bgColor = styles.get(bgColorParam);
  const actionsColor = styles.get(actionsColorParam);
  const spacing = styles.get(styleParams.layoutSpacing);
  const imagesPerRow = styles.get(styleParams.mediaImagesPerRow);
  const layout = styles.get(styleParams.mediaLayout) as EMediaLayout;

  return useMemo(
    () =>
      migrateOptions({
        titlePlacement:
          GALLERY_CONSTS.behaviourParams_item_overlay_hoveringBehaviour.APPEARS,
        allowTitle: true,
        allowDescription: true,
        allowDescriptionExpand: false,
        itemClick: GALLERY_CONSTS.behaviourParams_item_clickAction.MAGNIFY,

        enableInfiniteScroll: true,
        galleryLayout: MediaLayoutMap[layout],
        gallerySizeType: GALLERY_CONSTS.layoutParams_targetItemSize_unit.SMART,
        gridStyle: isMobile ? 0 : 1,
        floatingImages: 0,
        numberOfImagesPerRow: imagesPerRow,
        loadMoreAmount:
          GALLERY_CONSTS.behaviourParams_gallery_vertical_loadMore_amount
            .PARTIAL,

        gallerySize: isMobile ? 0 : 30,
        galleryMargin: 0,
        imageMargin: spacing,
        cubeType: GALLERY_CONSTS.layoutParams_crop_method.FILL,

        cubeRatio: 1,
        cubeImages: true,
        videoLoop: true,
        videoPlay: GALLERY_CONSTS.behaviourParams_item_video_playTrigger.HOVER,
        imageLoadingMode:
          GALLERY_CONSTS.behaviourParams_item_content_loader.COLOR,

        hoveringBehaviour:
          GALLERY_CONSTS.behaviourParams_item_overlay_hoveringBehaviour.APPEARS,
        scrollAnimation:
          GALLERY_CONSTS.behaviourParams_gallery_scrollAnimation.NO_EFFECT,
        overlayAnimation:
          GALLERY_CONSTS.behaviourParams_item_overlay_hoverAnimation.FADE_IN,
        imageHoverAnimation:
          GALLERY_CONSTS.behaviourParams_item_content_hoverAnimation.NO_EFFECT,

        bgColorExpand: bgColor,
        actionsColorExpand: actionsColor,
        groupTypes: isMobile ? '0' : '3',
      }),
    [bgColor, actionsColor, spacing, imagesPerRow, layout],
  );
}
